import { useState, useEffect } from 'react';

export function useCursor(blinkRate: number = 530) {
  const [cursorVisible, setCursorVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCursorVisible(prev => !prev);
    }, blinkRate);

    return () => clearInterval(interval);
  }, [blinkRate]);

  return { cursorVisible };
}